import { SettlementRecord } from '../models/SettlementRecord';
import { PaginatedApiState } from '../utils/requestAction';
import requestReducer from './requestReducer';

interface SettlementRecordsState extends PaginatedApiState {
  records?: SettlementRecord[]
}

export default requestReducer<SettlementRecordsState>('SETTLEMENT_RECORD_LIST')